import { useContext } from 'react';
import { element } from '../../../core/elements';
import { Arc } from '../../../primitives/shape/Arc';
import TooltipContext from '../../common/events/context/TooltipContext';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const DonutMarks = element(function DonutMarks(_ref) {
  let {
    arcs,
    labelAccessor
  } = _ref;
  const {
    tooltipData
  } = useContext(TooltipContext);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: arcs.map((arc, i) => {
      var _tooltipData$nearestD;
      return /*#__PURE__*/_jsx(Arc, {
        ariaLabel: arc.ariaLabel,
        datum: arc.data,
        innerRadius: arc.innerRadius,
        outerRadius: labelAccessor(tooltipData === null || tooltipData === void 0 ? void 0 : (_tooltipData$nearestD = tooltipData.nearestDatum) === null || _tooltipData$nearestD === void 0 ? void 0 : _tooltipData$nearestD.datum) === labelAccessor(arc.data) ? arc.outerRadius + arc.outerRadius * 0.05 : arc.outerRadius,
        startAngle: arc.startAngle,
        endAngle: arc.endAngle,
        padAngle: arc.padAngle,
        fill: arc.fill
      }, `Stack-${arc.key}-${i}`);
    })
  });
});